module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "contact-fade",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "banner"
  }, [(_vm.contact.form_header) ? _c('h3', {
    staticClass: "heading",
    style: ({
      color: _vm.cssPropColor('$color-primary')
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.contact.form_header)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.contact.form_intro) ? _c('div', {
    staticClass: "copy",
    domProps: {
      "innerHTML": _vm._s(_vm.contact.form_intro)
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-wrapper"
  }, [((_vm.contact.name && _vm.contact.show_company_name)) ? _c('div', {
    staticClass: "name",
    domProps: {
      "innerHTML": _vm._s(_vm.contact.name)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.contact.address1) ? _c('div', {
    staticClass: "address"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.contact.address1)
    }
  }), _vm._v(" "), (_vm.contact.address2) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.contact.address2)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.contact.city) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s((_vm.contact.city + ', ' + _vm.contact.state + ' ' + _vm.contact.zipcode))
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contact.phone) ? _c('div', {
    staticClass: "phone",
    domProps: {
      "innerHTML": _vm._s((((_vm.contact.fax) ? '(P) ' : '') + _vm.contact.phone))
    }
  }) : _vm._e(), _vm._v(" "), (_vm.contact.fax) ? _c('div', {
    staticClass: "fax",
    domProps: {
      "innerHTML": _vm._s((((_vm.contact.phone) ? '(F) ' : '') + _vm.contact.fax))
    }
  }) : _vm._e(), _vm._v(" "), (_vm.contact.email) ? _c('div', {
    staticClass: "email"
  }, [(_vm.isContactEmail(_vm.contact.email)) ? _c('a', {
    style: ({
      color: _vm.cssPropColor('$color-primary')
    }),
    attrs: {
      "href": 'mailto:' + (_vm.contact.email)
    }
  }, [_vm._v(_vm._s(_vm.contactUrlLabel))]) : _vm._e(), _vm._v(" "), (!_vm.isContactEmail(_vm.contact.email)) ? _c('a', {
    style: ({
      color: _vm.cssPropColor('$color-primary')
    }),
    attrs: {
      "href": _vm.contact.email,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.contactUrlLabel))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.submitted) ? _c('div', {
    key: "contact-form-a"
  }, [(_vm.hasContactFields) ? _c('form', {
    attrs: {
      "id": "contact-form-a",
      "name": "contact-form-a",
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.handleFormSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "required-note"
  }, [_vm._v("*Required")]), _vm._v(" "), (_vm.contactFieldVisibleBySlug('fullname')) ? _c('div', {
    staticClass: "form-row"
  }, [(_vm.contactFieldRequiredBySlug('fullname')) ? _c('input', {
    attrs: {
      "type": "text",
      "id": "fullname",
      "name": "fullname",
      "placeholder": (_vm.contactFieldLabelBySlug('fullname')),
      "tabindex": "1",
      "required": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.contactFieldRequiredBySlug('fullname')) ? _c('input', {
    attrs: {
      "type": "text",
      "id": "fullname",
      "name": "fullname",
      "placeholder": (_vm.contactFieldLabelBySlug('fullname')),
      "tabindex": "1"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contactFieldVisibleBySlug('address-1')) ? _c('div', {
    staticClass: "form-row"
  }, [(_vm.contactFieldRequiredBySlug('address-1')) ? _c('input', {
    attrs: {
      "type": "text",
      "id": "address-1",
      "name": "address-1",
      "placeholder": (_vm.contactFieldLabelBySlug('address-1')),
      "tabindex": "5",
      "required": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.contactFieldRequiredBySlug('address-1')) ? _c('input', {
    attrs: {
      "type": "text",
      "id": "address-1",
      "name": "address-1",
      "placeholder": (_vm.contactFieldLabelBySlug('address-1')),
      "tabindex": "5"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contactFieldVisibleBySlug('address-2')) ? _c('div', {
    staticClass: "form-row"
  }, [(_vm.contactFieldRequiredBySlug('address-2')) ? _c('input', {
    attrs: {
      "type": "text",
      "id": "address-2",
      "name": "address-2",
      "placeholder": (_vm.contactFieldLabelBySlug('address-2')),
      "tabindex": "10",
      "required": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.contactFieldRequiredBySlug('address-2')) ? _c('input', {
    attrs: {
      "type": "text",
      "id": "address-2",
      "name": "address-2",
      "placeholder": (_vm.contactFieldLabelBySlug('address-2')),
      "tabindex": "10"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contactFieldVisibleBySlug('city')) ? _c('div', {
    staticClass: "form-row"
  }, [(_vm.contactFieldRequiredBySlug('city')) ? _c('input', {
    attrs: {
      "type": "text",
      "id": "city",
      "name": "city",
      "placeholder": (_vm.contactFieldLabelBySlug('city')),
      "tabindex": "15",
      "required": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.contactFieldRequiredBySlug('city')) ? _c('input', {
    attrs: {
      "type": "text",
      "id": "city",
      "name": "city",
      "placeholder": (_vm.contactFieldLabelBySlug('city')),
      "tabindex": "15"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), ((_vm.contactFieldVisibleBySlug('state') || _vm.contactFieldVisibleBySlug('zipcode'))) ? _c('div', {
    staticClass: "form-row"
  }, [(_vm.contactFieldVisibleBySlug('state') && _vm.contactFieldRequiredBySlug('state')) ? _c('select', {
    staticClass: "flex-50",
    attrs: {
      "name": "state",
      "tabindex": "20",
      "required": ""
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.stateProvinceLabel) + "*")]), _vm._v(" "), _vm._l((_vm.stateProvinceOptions[_vm.form.country]), function(option) {
    return _c('option', {
      domProps: {
        "value": option.code
      }
    }, [_vm._v(_vm._s(option.name))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.contactFieldVisibleBySlug('state') && !_vm.contactFieldVisibleBySlug('state')) ? _c('select', {
    staticClass: "flex-50",
    attrs: {
      "name": "state",
      "tabindex": "20",
      "required": _vm.contactFieldRequiredBySlug('state')
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.stateProvinceLabel) + "*")]), _vm._v(" "), _vm._l((_vm.stateProvinceOptions[_vm.form.country]), function(option) {
    return _c('option', {
      domProps: {
        "value": option.code
      }
    }, [_vm._v(_vm._s(option.name))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.contactFieldVisibleBySlug('zipcode') && _vm.contactFieldRequiredBySlug('zipcode')) ? _c('input', {
    staticClass: "flex-50",
    attrs: {
      "type": "text",
      "id": "zipcode",
      "name": "zipcode",
      "value": "",
      "placeholder": (_vm.contactFieldLabelBySlug('zipcode')),
      "tabindex": "25",
      "required": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.contactFieldVisibleBySlug('zipcode') && !_vm.contactFieldRequiredBySlug('zipcode')) ? _c('input', {
    staticClass: "flex-50",
    attrs: {
      "type": "text",
      "id": "zipcode",
      "name": "zipcode",
      "value": "",
      "placeholder": (_vm.contactFieldLabelBySlug('zipcode')),
      "tabindex": "25"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contactFieldVisibleBySlug('country')) ? _c('div', {
    staticClass: "form-row"
  }, [(_vm.contactFieldRequiredBySlug('country')) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.country),
      expression: "form.country"
    }],
    attrs: {
      "id": "country",
      "name": "country",
      "tabindex": "30",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "US",
      "selected": ""
    }
  }, [_vm._v("United States")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CA"
    }
  }, [_vm._v("Canada")])]) : _vm._e(), _vm._v(" "), (!_vm.contactFieldRequiredBySlug('country')) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.country),
      expression: "form.country"
    }],
    attrs: {
      "id": "country",
      "name": "country",
      "tabindex": "30"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "US",
      "selected": ""
    }
  }, [_vm._v("United States")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CA"
    }
  }, [_vm._v("Canada")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contactFieldVisibleBySlug('phone')) ? _c('div', {
    staticClass: "form-row"
  }, [(_vm.contactFieldRequiredBySlug('phone')) ? _c('input', {
    attrs: {
      "type": "tel",
      "id": "phone",
      "name": "phone",
      "placeholder": "Phone Number*",
      "tabindex": "35",
      "required": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.contactFieldRequiredBySlug('phone')) ? _c('input', {
    attrs: {
      "type": "tel",
      "id": "phone",
      "name": "phone",
      "placeholder": "Phone Number*",
      "tabindex": "35"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contactFieldVisibleBySlug('email')) ? _c('div', {
    staticClass: "form-row"
  }, [(_vm.contactFieldRequiredBySlug('email')) ? _c('input', {
    attrs: {
      "type": "email",
      "id": "email",
      "name": "email",
      "placeholder": "Email Address*",
      "tabindex": "40",
      "required": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.contactFieldRequiredBySlug('email')) ? _c('input', {
    attrs: {
      "type": "email",
      "id": "email",
      "name": "email",
      "placeholder": "Email Address*",
      "tabindex": "40"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), ((_vm.contact.form_type === 'sign-up' && _vm.contactFieldVisibleBySlug('policy-number'))) ? _c('div', {
    staticClass: "form-row"
  }, [(_vm.contactFieldRequiredBySlug('policy-number')) ? _c('input', {
    attrs: {
      "type": "text",
      "id": "policy-number",
      "name": "policy-number",
      "placeholder": "Policy Number",
      "tabindex": "45",
      "required": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.contactFieldRequiredBySlug('policy-number')) ? _c('input', {
    attrs: {
      "type": "text",
      "id": "policy-number",
      "name": "policy-number",
      "placeholder": "Policy Number",
      "tabindex": "45"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contactFieldVisibleBySlug('contact-method')) ? _c('div', {
    staticClass: "form-row"
  }, [(_vm.contactFieldRequiredBySlug('contact-method')) ? _c('select', {
    attrs: {
      "id": "contact-method",
      "name": "contact-method",
      "tabindex": "47",
      "required": ""
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    },
    domProps: {
      "innerHTML": _vm._s((_vm.contactFieldLabelBySlug('contact-method')))
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Phone"
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Email"
    }
  }, [_vm._v("Email")])]) : _vm._e(), _vm._v(" "), (!_vm.contactFieldRequiredBySlug('contact-method')) ? _c('select', {
    attrs: {
      "id": "contact-method",
      "name": "contact-method",
      "tabindex": "47"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    },
    domProps: {
      "innerHTML": _vm._s((_vm.contactFieldLabelBySlug('contact-method')))
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Phone"
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Email"
    }
  }, [_vm._v("Email")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-row not-a-bot align-center justify-center"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "not-a-bot",
      "id": "not-a-bot",
      "tabindex": "50",
      "required": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "not-a-bot"
    }
  }, [_vm._v("I am not a robot.*")])]), _vm._v(" "), _c('div', {
    staticClass: "form-row align-center justify-center"
  }, [_c('button', {
    staticClass: "btn",
    class: {
      disabled: _vm.submitting
    },
    style: ({
      backgroundColor: _vm.cssPropColor('$color-secondary')
    }),
    attrs: {
      "type": "submit",
      "tabindex": "55",
      "disabled": _vm.submitting
    }
  }, [_vm._v("Submit")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.submitting) ? _c('div', {
    staticClass: "form-row align-center justify-center"
  }, [_c('span', {
    staticClass: "note"
  }, [_vm._v("Transmitting your submission, please wait...")])]) : _vm._e()]), _vm._v(" "), (_vm.contact.slug) ? _c('input', {
    attrs: {
      "type": "hidden",
      "id": "company",
      "name": "company"
    },
    domProps: {
      "value": _vm.contact.slug
    }
  }) : _vm._e(), _vm._v(" "), (_vm.contact.form_type) ? _c('input', {
    attrs: {
      "type": "hidden",
      "id": "form-type",
      "name": "form-type"
    },
    domProps: {
      "value": _vm.contact.form_type
    }
  }) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.submitted) ? _c('div', {
    key: "form-thanks",
    staticClass: "form-thanks"
  }, [_c('hr'), _vm._v(" "), _c('h3', {
    staticClass: "heading",
    domProps: {
      "innerHTML": _vm._s(_vm.contact.form_thanks_title)
    }
  }), _vm._v(" "), (_vm.contact.form_thanks_msg) ? _c('div', {
    staticClass: "copy",
    domProps: {
      "innerHTML": _vm._s(_vm.contact.form_thanks_msg)
    }
  }) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "btn",
    on: {
      "click": _vm.backToExposures
    }
  }, [_vm._v("Back to Exposures")])]) : _vm._e()])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17913b96","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileContentContact.vue
// module id = 447
// module chunks = 1